// extracted by css-extract-rspack-plugin
export default {"sidebar":"WJPB4"};